import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { fetchCustomType } from "PFCore/services/custom_types";
import { CustomType } from "PFTypes/custom_type";

import { customTypeKeys } from "./query_keys";

export const useCustomType = (
  id: number,
  options: Omit<UseQueryOptions<CustomType>, "queryKey" | "queryFn">
) =>
  useQuery<CustomType>(
    customTypeKeys.single(id),
    () => fetchCustomType(id) as unknown as Promise<CustomType>,
    {
      retry: false,
      ...options
    }
  );
